class SectionDataCollectionForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.checkRequiredState()
    this.checkConfirmState()
  }

  setupListeners () {
    super.setupListeners()

    if (this?.els?.required?.exists && this?.els?.submit?.exists) {
      this.els.required.elements.forEach(requiredEl => {
        this.listeners.add(
          requiredEl,
          'input',
          this.checkRequiredState.bind(this),
        )
      })
    }

    // If reset button exists, add listener to reset all fields
    if (this.els.reset?.exists) {
      this.listeners.add(
        this.els.reset.element,
        'click',
        this.resetFields.bind(this),
      )
    }

    if (this.els.select?.exists) {
      this.els.select.elements.forEach(selectEl => {
        this.listeners.add(
          selectEl,
          'change',
          this.handleSelectChange.bind(this),
        )
      })
    }

    // If there is a text element of type textarea, add listener to count characters.
    if (this.els.textarea?.exists) {
      this.els.textarea.elements.forEach(textareaEl => {
        this.listeners.add(
          textareaEl,
          'input',
          this.handleTextareaInput.bind(this),
        )
      })
    }
  }

  handleTextareaInput (event) {
    const textareaEl = event.target

    // Get max characters from the element.
    const maxCharacters = Number(this.els.max?.element?.dataset.max)

    // Get the closest header element.
    const thisTextArea = textareaEl.closest('[data-section-data-collection-form-el="textareafield"]')

    if (thisTextArea !== null) {
      // Get the character count element that corresponds to the textarea.
      const characterCount = thisTextArea.querySelector('[data-section-data-collection-form-el="count"]')

      // Update the character count with the used characters.
      if (characterCount) {
        characterCount.textContent = textareaEl.value.length
      }
    }

    // If the max characters is reached, prevent further input.
    if (textareaEl.value.length >= maxCharacters) {
      textareaEl.value = textareaEl.value.substr(0, maxCharacters)
    }
  }

  handleSelectChange (event) {
    const selectEl = event.target

    if (selectEl.selectedIndex === 0) {
      selectEl.classList.remove('frm-DataCapture_Select-selected')
    } else {
      selectEl.classList.add('frm-DataCapture_Select-selected')
    }
  }

  resetFields () {
    // Reset all selects.
    if (this.els.select?.exists) {
      this.els.select.elements.forEach(selectEl => {
        selectEl.selectedIndex = 0

        selectEl.classList.remove('frm-DataCapture_Select-selected')
      })
    }

    // Reset all text inputs.
    if (this.els.text?.exists) {
      this.els.text.elements.forEach(textEl => {
        textEl.value = ''
      })
    }

    // Reset all textareas.
    if (this.els.textarea?.exists) {
      this.els.textarea.elements.forEach(textareaEl => {
        textareaEl.value = ''
      })
    }

    // Reset all textarea counts.
    if (this.els.count?.exists) {
      this.els.count.elements.forEach(countEl => {
        countEl.textContent = '0'
      })
    }
  }

  checkConfirmState () {
    if (this.els.confirm?.exists && this.els.submit?.exists) {
      if (this.els.confirm.element.checked === true) {
        this.els.submit.element.ariaDisabled = false
      } else {
        this.els.submit.element.ariaDisabled = true
      }
    }
  }

  checkRequiredState () {
    let allAreFilled = true

    if (!this.els.required?.exists || !this.els.submit?.exists) return

    this.els.required.elements.every(requiredEl => {
      if (requiredEl.type === 'text' && requiredEl.value.length === 0) {
        allAreFilled = false

        return false
      }

      if (requiredEl.type === 'email') {
        if (requiredEl.value.length === 0 || !requiredEl.validity.valid) {
          allAreFilled = false

          return false
        }
      }

      if (requiredEl.type === 'password' && requiredEl.value.length === 0) {
        allAreFilled = false

        return false
      }

      if (requiredEl.type === 'checkbox' && requiredEl.checked !== true) {
        allAreFilled = false

        return false
      }

      return true
    })

    this.els.submit.element.ariaDisabled = !allAreFilled
  }
}

customElements.define('section-data-collection-form', SectionDataCollectionForm)
